import React from "react";
import { useLang } from "../../i18n/LanguageContext";

const Footer = () => {
  const { t } = useLang();
  const year = new Date().getFullYear();

  return (
    <footer data-testid="site-footer" className="bg-[#111] text-white border-t border-[#262626]">
      <div className="container-x py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 items-center">
          <div className="md:col-span-7">
            <img
              src="/aark-logo-white.png"
              alt="AARK"
              className="w-full max-w-[640px] h-auto select-none"
              draggable="false"
            />
          </div>
          <div className="md:col-span-5 md:text-right">
            <p className="text-[#A3A3A3] max-w-xs md:ml-auto leading-relaxed">
              {t("footer.tagline")}
            </p>
            <div className="mt-6 font-mono-label text-[#A89F91]">{t("contact.info.phone")}</div>
            <div className="font-mono-label text-[#A89F91]">{t("contact.info.email")}</div>
          </div>
        </div>
      </div>
      <div className="border-t border-[#262626]">
        <div className="container-x py-6 flex flex-col md:flex-row md:items-center md:justify-between gap-3">
          <div className="font-mono-label text-[#A3A3A3]">
            © {year} AARK · {t("footer.copyright")}
          </div>
          <div className="font-mono-label text-[#A3A3A3]">
            {t("footer.legal")}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
